import { useDispatch, useSelector } from 'react-redux';
import { ApplicationStore } from '../../types/AppState.type';
import { setTheme } from "../reducers/themeSlice";

export const useTheme = (): [ApplicationStore.AppThemeState, (parameter: string) => any] => {
    const dispatch = useDispatch();

    return [useSelector((state: ApplicationStore.CombineState) => state.ThemeState),
    (themeName: string) => { return dispatch(setTheme(themeName)) }];
}